'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesTotals = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _currencies = require('../../../utils/currencies');

var fetchEvent = function fetchEvent(id) {
  return (0, _client.get)('v1/event/' + id + '/pages').then(function (response) {
    return response.totalFundraisingPages;
  });
};

var fetchCampaign = function fetchCampaign(id) {
  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + id + '/leaderboard').then(function (_ref) {
    var data = _ref.data;
    return data.meta.totalResults;
  });
};

var fetchCampaignTeams = function fetchCampaignTeams(id) {
  return _client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/search', {
    params: { CampaignGuid: id },
    paramsSerializer: _params.paramsSerializer
  }).then(function (response) {
    return response.data.totalResults;
  });
};

var fetchPagesTotals = exports.fetchPagesTotals = function fetchPagesTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      var eventIds = Array.isArray(params.event) ? params.event : [params.event];

      return Promise.all(eventIds.map(_params.getUID).map(fetchEvent)).then(function (events) {
        return events.reduce(function (acc, total) {
          return acc + total;
        }, 0);
      });
    case 'campaign':
      if (params.type === 'team') {
        var campaignIds = Array.isArray(params.campaign) ? params.campaign : [params.campaign];

        return Promise.all(campaignIds.map(_params.getUID).map(fetchCampaignTeams)).then(function (campaigns) {
          return campaigns.reduce(function (acc, total) {
            return acc + total;
          }, 0);
        });
      } else {
        var _campaignIds = Array.isArray(params.campaign) ? params.campaign : [params.campaign];

        return Promise.all(_campaignIds.map(_params.getUID).map(fetchCampaign)).then(function (campaigns) {
          return campaigns.reduce(function (acc, total) {
            return acc + total;
          }, 0);
        });
      }
    default:
      return (0, _client.get)('donationsleaderboards/v1/leaderboard', _extends({}, params, {
        currencyCode: (0, _currencies.currencyCode)(params.country)
      }), {
        mappings: {
          campaign: 'campaignGuids',
          charity: 'charityIds',
          page: 'pageGuids',
          excludePageIds: 'excludePageGuids',
          limit: 'take'
        },
        transforms: {
          campaign: _params.splitOnDelimiter,
          charity: _params.splitOnDelimiter,
          excludePageIds: _params.splitOnDelimiter
        }
      }, { paramsSerializer: _params.paramsSerializer }).then(function (data) {
        return data.totalResults;
      });
  }
};